<template>
  <div class="block_center">
    <template v-if="totalShow">
      <!-- 顶部搜索横幅 -->
      <div id="searchBanner" class="searchBanner">
        <div class="bannerContent">
          <h1 class="bannerTitle">{{ $t("Service.searchBannerTitle") }}</h1>
          <div class="searchBox">
            <el-input
                v-model="searchKeyword"
                :placeholder="$t('Service.searchPlaceholder')"
                prefix-icon="el-icon-search"
                clearable
                @keyup.enter.native="handleSearch"
                @clear="handleSearchClear"
            >
              <template slot="append">
                <el-button type="primary" @click.native.stop="handleSearch">
                  {{ $t("Service.searchButton") }}
                </el-button>
              </template>
            </el-input>
          </div>
        </div>
      </div>

      <!-- 顶部功能卡片区 -->
      <div class="featureCards">
        <div
            class="featureCard"
            v-for="(item, index) in featureList"
            :key="index"
            @click="handleFeatureClick(item)"
        >
          <div class="cardIcon">
            <img :src="item.imgSrc" alt="" />
          </div>
          <div class="cardTitle">{{ item.title }}</div>
        </div>
      </div>

      <!-- 热点·相关·问题 -->
      <div id="feedbackSection" class="hotQuestions">
        <div class="sectionHeader">
          <h2 class="sectionTitle">{{ $t("Service.hotQuestionsTitle") }}</h2>
        </div>
        <div class="questionList">
          <div
              class="questionItem"
              :class="{ expanded: item.expanded }"
              v-for="(item, index) in hotQuestionList"
              :key="index"
          >
            <div class="questionHeader" @click="toggleQuestion(index)">
              <div class="questionContent">
                <div class="questionTitle">{{ item.title }}</div>
              </div>
              <i
                  class="el-icon-arrow-down questionArrow"
                  :class="{ rotated: item.expanded }"
              ></i>
            </div>
            <div v-if="item.expanded" class="questionAnswer" v-html="item.answer"></div>
          </div>

          <div class="viewMoreWrapper">
            <div
                class="viewMoreBtn"
                @click="handleFeatureClick({ type: 'ques' })"
            >
              <span>{{ $t("Service.viewMore") }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 联系我们 -->
      <div id="contactSection" class="contactSection">
        <h2 class="contactTitle">{{ $t("Service.contactUsTitle") }}</h2>
        <div class="contactContainer">
          <div class="customerServiceContent">
            <div class="contactQrcode">
              <div class="qrcodeWrapper">
                <img
                    :src="contactQrcodeUrl || require('@/assets/image/companyContact.feafc1ee.jpg@3x.png')"
                    alt="企业微信"
                    class="qrcodeImg"
                />
              </div>
              <div class="qrcodeScan">{{ $t("Service.qrcodeScan") }}</div>
              <div class="qrcodeLabel">{{ $t("Service.qrcodeServiceTip") }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <VideoTutorial v-if="videoTutorialShow" @back="handleDetailBack" :auto-play-id="pendingVideoId" @played="pendingVideoId = ''" />
    <videoTutorialPageDown v-if="videoTutorialShow1" @back="handleDetailBack" :auto-play-id="pendingVideoId" @played="pendingVideoId = ''" />

    <FaqPage
        v-if="faqPageShow"
        :init-keyword="faqSearchKeyword"
        :target-id="pendingTargetId"
        @back="handleDetailBack"
    />

    <PdfDownloadPage v-if="pdfDownloadShow" :target-id="pendingTargetId" @back="handleDetailBack" />
    <UpdateLogPage v-if="updateLogShow" :target-id="pendingTargetId" @back="handleDetailBack" />

    <SearchResultPage
        v-if="searchResultShow"
        :init-keyword="searchResultKeyword"
        @back="showTotal"
        @navigate="handleSearchNavigate"
    />
  </div>
</template>

<script>
import { submitFeedbackAPI } from "@/assets/API/user";
import { supportQuestion } from "@/assets/API/service";
import { getContactUsInfo } from "@/assets/API/home";
import define from "@/utils/define";
import VideoTutorial from "./ServiceSupport/videoTutorialPage.vue";
import videoTutorialPageDown from "./ServiceSupport/videoTutorialPageDown.vue";
import FaqPage from "./ServiceSupport/faqPage.vue";
import PdfDownloadPage from "./ServiceSupport/pdfDownloadPage.vue";
import UpdateLogPage from "./ServiceSupport/updateLogPage.vue";
import SearchResultPage from "./ServiceSupport/SearchResultPage.vue";

export default {
  components: {
    VideoTutorial,
    videoTutorialPageDown,
    FaqPage,
    PdfDownloadPage,
    UpdateLogPage,
    SearchResultPage,
  },

  data() {
    return {
      // 反馈表单
      feedbackForm: {
        name: "",
        email: "",
        subject: "",
        content: "",
      },

      // 首页搜索框关键词
      searchKeyword: "",

      // 传给 FAQ 页面使用的查询关键词
      faqSearchKeyword: "",

      totalShow: true,
      videoTutorialShow: false,
      videoTutorialShow1: false,
      // 搜索结果跳转视频页时待定位自动播放的视频id
      pendingVideoId: "",
      pendingTargetId: "",
      detailFromSearch: false,
      faqPageShow: false,
      pdfDownloadShow: false,
      updateLogShow: false,
      searchResultShow: false,
      searchResultKeyword: "",
      hotQuestionList: [],
      // 联系我们信息（从接口获取）
      contactInfo: {
        addres: "",
        email: "",
        wecomQr: "",
      },
    };
  },

  computed: {
    language() {
      return this.$i18n.locale;
    },

    // 企业微信二维码图片地址（wecomQr 为 Summit-UploadImg 序列化的 JSON 字符串）
    contactQrcodeUrl() {
      const wecomQr = this.contactInfo.wecomQr;
      if (!wecomQr) return "";
      try {
        const parsed = JSON.parse(wecomQr);
        const url = Array.isArray(parsed) ? parsed[0]?.url : parsed?.url;
        if (!url) return "";
        return /^https?:\/\//.test(url) ? url : define.APIURl + url;
      } catch (e) {
        return "";
      }
    },

    featureList() {
      return [
        {
          title: this.$t("Service.mediaTitle"),
          type: "media",
          imgSrc: require("@/assets/image/video.png"),
        },
        {
          title: this.$t("Service.videoTitle"),
          type: "manual",
          imgSrc: require("@/assets/image/video1.png"),
        },
        {
          title: this.$t("Service.downloadTitle"),
          type: "pdf",
          imgSrc: require("@/assets/image/download1.png"),
        },
        {
          title: this.$t("Service.newsTitle"),
          type: "news",
          imgSrc: require("@/assets/image/update.png"),
        },
      ];
    },

    feedbackRules() {
      return {
        name: [
          {
            required: true,
            message: this.$t("Service.nameRequired"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("Service.emailRequired"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("Service.emailFormat"),
            trigger: "blur",
          },
        ],
        subject: [
          {
            required: true,
            message: this.$t("Service.subjectRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("Service.contentRequired"),
            trigger: "blur",
          },
        ],
      };
    },
  },

  mounted() {
    const { type } = this.$route.query;

    if (type) {
      this.activeItem = type - 1;

      this.$nextTick(() => {
        let anchor = "";

        switch (type) {
          case "update":
            anchor = "searchBanner";
            break;
          case "contact":
            anchor = "contactSection";
            break;
          case "feedback":
            anchor = "feedbackSection";
            break;
          default:
            anchor = "searchBanner";
        }

        const element = document.getElementById(anchor);

        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      });
    }

    this.getQuestionList();
    this.getContactInfo();
  },

  watch: {
    $route: {
      handler(newVal) {
        switch (true) {
          case ["/Service"].indexOf(newVal.path) != -1:
            if (newVal.query.type) {
              // 保留原逻辑
            } else {
              this.totalShow = true;
            }
            break;
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    // 首页搜索
    handleSearch() {
      const keyword = this.searchKeyword ? this.searchKeyword.trim() : "";

      if (!keyword) {
        this.$message.warning(
            this.$t("Service.searchPlaceholder") || "请输入查询内容"
        );
        return;
      }

      this.searchResultKeyword = keyword;

      this.totalShow = false;
      this.videoTutorialShow = false;
      this.videoTutorialShow1 = false;
      this.faqPageShow = false;
      this.pdfDownloadShow = false;
      this.updateLogShow = false;
      this.searchResultShow = true;

      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    },

    // 清空首页搜索框
    handleSearchClear() {
      this.searchKeyword = "";
    },

    // 功能卡片点击
    handleFeatureClick(item, fromSearch = false) {
      if (!fromSearch) {
        this.pendingVideoId = "";
        this.pendingTargetId = "";
        this.detailFromSearch = false;
      }
      switch (item.type) {
        case "manual":
          this.totalShow = false;
          this.videoTutorialShow = true;
          this.videoTutorialShow1 = false;
          this.faqPageShow = false;
          this.pdfDownloadShow = false;
          this.updateLogShow = false;
          break;

        case "pdf":
          this.totalShow = false;
          this.videoTutorialShow = false;
          this.videoTutorialShow1 = false;
          this.faqPageShow = false;
          this.pdfDownloadShow = true;
          this.updateLogShow = false;
          break;

        case "ques":
          this.totalShow = false;
          this.videoTutorialShow = false;
          this.videoTutorialShow1 = false;
          this.faqPageShow = true;
          this.pdfDownloadShow = false;
          this.updateLogShow = false;
          break;

        case "media":
          this.totalShow = false;
          this.videoTutorialShow = false;
          this.videoTutorialShow1 = true;
          this.faqPageShow = false;
          this.pdfDownloadShow = false;
          this.updateLogShow = false;
          break;

        case "news":
          this.totalShow = false;
          this.videoTutorialShow = false;
          this.videoTutorialShow1 = false;
          this.faqPageShow = false;
          this.pdfDownloadShow = false;
          this.updateLogShow = true;
          break;
      }

      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    },

    // 提交反馈
    submitFeedback() {
      this.$refs.feedbackFormRef.validate((valid) => {
        if (valid) {
          const formData = new FormData();

          formData.append("name", this.feedbackForm.name);
          formData.append("mobile", this.feedbackForm.email);
          formData.append("company", this.feedbackForm.subject);
          formData.append("feedback", this.feedbackForm.content);

          submitFeedbackAPI(formData)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success(this.$t("Service.feedbackSuccess"));
                  this.feedbackForm = {
                    name: "",
                    email: "",
                    subject: "",
                    content: "",
                  };
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch(() => {
                this.$message.error(this.$t("Service.feedbackError"));
              });
        }
      });
    },

    showTotal() {
      this.totalShow = true;
      this.videoTutorialShow = false;
      this.videoTutorialShow1 = false;
      this.faqPageShow = false;
      this.pdfDownloadShow = false;
      this.updateLogShow = false;
      this.searchResultShow = false;
      this.searchResultKeyword = "";
      this.pendingVideoId = "";
      this.pendingTargetId = "";
      this.detailFromSearch = false;
    },

    handleDetailBack() {
      if (!this.detailFromSearch) {
        this.showTotal();
        return;
      }
      this.totalShow = false;
      this.videoTutorialShow = false;
      this.videoTutorialShow1 = false;
      this.faqPageShow = false;
      this.pdfDownloadShow = false;
      this.updateLogShow = false;
      this.searchResultShow = true;
      this.pendingVideoId = "";
      this.pendingTargetId = "";
      this.detailFromSearch = false;
      this.$nextTick(() => window.scrollTo({ top: 0, behavior: "smooth" }));
    },

    // 搜索结果页点击条目 → 跳转对应子页面
    handleSearchNavigate(type, id) {
      this.searchResultShow = false;
      this.detailFromSearch = true;
      // 视频类结果：记录目标id，视频页加载后定位并自动播放
      this.pendingVideoId = (type === "manual" || type === "media") ? id : "";
      this.pendingTargetId = (type === "pdf" || type === "ques" || type === "news") ? id : "";
      this.handleFeatureClick({ type }, true);
    },

    toggleQuestion(index) {
      this.$set(
          this.hotQuestionList,
          index,
          { ...this.hotQuestionList[index], expanded: !this.hotQuestionList[index].expanded }
      );
    },

    getQuestionList() {
      supportQuestion({
        currentPage: 1,
        pageSize: 6,
      }).then((res) => {
        if (res.code === 200 && res.data.records) {
          this.hotQuestionList = res.data.records.map((item) => ({
            title: this.language == "zh" ? item.title : item.titleEn,
            answer: this.language == "zh" ? item.content : item.contentEn,
            expanded: false,
          }));
        }
      });
    },

    // 获取联系我们信息
    getContactInfo() {
      getContactUsInfo().then((res) => {
        if (res.code === 200 && res.data) {
          this.contactInfo = {
            addres: res.data.addres || "",
            addresEn: res.data.addresEn || "",
            email: res.data.email || "",
            wecomQr: res.data.wecomQr || "",
          };
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.block_center {
  padding-top: 80px;
  background: #f9fafc;
  min-height: 100vh;
}

.searchBanner {
  position: relative;
  height: 300px;
  width: 100%;
  background: url("../../../assets/image/services_bg.png") no-repeat center;
  background-size: cover;

  .bannerContent {
    position: relative;
    z-index: 1;
    width: 1350px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .bannerTitle {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
    letter-spacing: 2px;
  }

  .searchBox {
    width: 550px;

    ::v-deep .el-input {
      .el-input__inner {
        height: 48px;
        border-radius: 8px 0 0 8px;
        border: 1px solid #e0e0e0;
        border-right: none;
        font-size: 14px;
        padding-left: 40px;
        padding-right: 130px;
        background: #fff;

        &::placeholder {
          color: #bbb;
        }

        &:focus {
          border-color: #2b85e5;
        }
      }

      .el-input__prefix {
        left: 12px;

        .el-input__icon {
          font-size: 18px;
          color: #999;
          line-height: 48px;
        }
      }

      /* 清除按钮显示在 append 按钮左侧，不被遮挡 */
      .el-input__suffix {
        right: 4%;

        .el-input__icon {
          line-height: 48px;
        }
      }

      .el-input-group__append {
        background: transparent;
        border: none;
        padding: 0;

        .el-button {
          height: 48px;
          border-radius: 0 8px 8px 0;
          padding: 0 28px;
          font-size: 15px;
          background: #2b85e5;
          border-color: #2b85e5;
          color: #fff;

          &:hover {
            background: #1a73d4;
            border-color: #1a73d4;
          }
        }
      }
    }
  }
}

/* 功能卡片区 */
/* 功能卡片区（样式与“按需订阅”家族卡片一致） */
.featureCards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 160px; /* 固定行高，卡片高度变化不撑大背景 */
  gap: 20px;
  /* 背景容器高度固定，不随卡片 hover 变化 */
  height: 200px;
  width: 1350px;
  margin: 27px auto 40px;
  padding: 20px 160px 0; /* 底部 padding 为 0，让卡片底部贴容器底部 */
  box-sizing: border-box;
  border-radius: 8px;
  overflow: visible; /* 允许卡片顶部突出背景 */
  background: linear-gradient(180deg, rgba(232, 240, 249, 1) 0%, rgba(255, 255, 255, 0) 100%);
  box-shadow: 0 2px 19px rgba(0, 0, 0, 0.03);

  .featureCard {
    align-self: end; /* 卡片底部对齐，hover 时向上生长 */
    height: 160px;
    border-radius: 14px;
    padding: 16px 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.28s ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* hover：高度增大，底部贴容器底部（一体），上半部分突出背景容器顶部 */
    &:hover {
      height: 200px;
      border-radius: 14px 14px 0 0; /* 底部去圆角，与外层底部一体 */
      background: linear-gradient(180deg, rgba(242, 248, 255, 1) 0%, rgba(255, 255, 255, 1) 100%);
      box-shadow: 0 4px 16px rgba(43, 133, 229, 0.12);
      z-index: 2;

      .cardTitle {
        color: #2b85e5;
      }
    }

    .cardIcon {
      width: 64px;
      height: 64px;
      margin: 0 auto 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }

    .cardTitle {
      font-size: 18px;
      font-weight: 600;
      color: #1a2b4b;
      line-height: 1.4;
    }
  }
}

/* 热点问题区 */
.hotQuestions {
  width: 1350px;
  margin: 0 auto;
  padding: 40px 0px 60px;

  .sectionHeader {
    text-align: center;
    margin-bottom: 40px;

    .sectionTitle {
      font-size: 28px;
      font-weight: 600;
      color: #333;
    }
  }

  .questionList {
    background: linear-gradient(
            180deg,
            rgba(232, 240, 249, 1) 0%,
            rgba(255, 255, 255, 0) 100%
    );
    padding: 45px;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);

    .questionItem {
      overflow: hidden;
      transition: all 0.3s;
      border-bottom: 1px solid #e5e5e5;

      &.expanded {
        .questionArrow {
          opacity: 1;
          color: #2b85e5;
        }
      }

      .questionHeader {
        display: flex;
        align-items: center;
        padding: 15px 0;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          .questionArrow {
            opacity: 1;
            color: #2b85e5;
          }
        }
      }

      .questionContent {
        flex: 1;

        .questionTitle {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          margin-bottom: 4px;
        }
      }

      .questionArrow {
        font-size: 16px;
        color: #ccc;
        opacity: 0.6;
        transition: all 0.3s;

        &.rotated {
          transform: rotate(180deg);
          opacity: 1;
          color: #2b85e5;
        }
      }

      .questionAnswer {
        font-size: 14px;
        color: #666;
        line-height: 1.9;
        word-break: break-word;
        padding: 12px 0 16px;

        ::v-deep img {
          max-width: 100%;
          height: auto;
          object-fit: contain;
        }

        ::v-deep p {
          margin: 0;
        }
      }
    }
  }

  .viewMoreWrapper {
    display: flex;
    justify-content: center;
    margin-top: 2px;

    .viewMoreBtn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 12px 32px;
      font-size: 14px;
      color: #2b85e5;
      background: transparent;
      border-radius: 24px;
      cursor: pointer;
      transition: all 0.3s;

      i {
        font-size: 12px;
        transition: transform 0.3s;
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.contactSection {
  width: 1350px;
  margin: 0 auto;
  padding: 60px 0;

  .contactTitle {
    font-size: 35px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 50px;
  }

  .contactContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-height: 413px;
    box-sizing: border-box;
    background: url("../../../assets/image/cst_service_bg.png") no-repeat center;
    background-size: cover;
    border-radius: 16px;
    padding: 28px 92px 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  }

  .customerServiceContent {
    width: 48%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contactQrcode {
    display: flex;
    flex-direction: column;
    align-items: center;

    .qrcodeWrapper {
      width: 166px;
      height: 166px;

      .qrcodeImg {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .qrcodeScan {
      margin-top: 14px;
      color: #333;
      font-size: 18px;
      line-height: 1.4;
    }

    .qrcodeLabel {
      color: #333;
      font-size: 18px;
      line-height: 1.4;
    }
  }
}

/* 反馈表单区 */
.feedbackSection {
  width: 1350px;
  margin: 0 auto;
  padding: 40px 0px 80px;

  .sectionHeader {
    text-align: center;
    margin-bottom: 30px;

    .sectionTitle {
      font-size: 28px;
      font-weight: 600;
      color: #333;
    }

    .sectionSubtitle {
      font-size: 14px;
      color: #999;
      margin-top: 8px;
    }
  }

  .feedbackForm {
    background: #fff;
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);

    .formRow {
      display: flex;
      gap: 20px;

      .formItemHalf {
        flex: 1;
      }
    }

    ::v-deep .el-form-item__label {
      font-weight: 500;
      color: #333;
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-textarea__inner {
      border-radius: 8px;
      border-color: #e5e5e5;

      &:focus {
        border-color: #667eea;
      }
    }

    .formFooter {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 24px;

      .formTip {
        font-size: 13px;
        color: #999;
      }

      .submitBtn {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 8px;
        padding: 12px 32px;
        font-size: 15px;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}

/* 保留原有样式 */
.mainCenter {
  width: 1200px;
  margin: 0 auto;
}

.banner {
  display: none;
}

.guideContent {
  background: rgba(247, 248, 251, 1);
}

.guide {
  padding-top: 60px;
  justify-content: flex-start !important;
  width: 1200px;
  margin: 0 auto;
  background: rgba(247, 248, 251, 1);
}

::v-deep .no-asterisk .el-form-item__label::before {
  display: none !important;
}
</style>
